import React, { useRef } from 'react';
import {
  IonItemSliding,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonImg
} from '@ionic/react';
import { Shipment } from '../models/Shipment';

interface ShipmentCardProps {
  shipment?: Shipment;
  hide: boolean;
}

const ShipmentCard: React.FC<ShipmentCardProps> = ({
  shipment,
  hide,
}) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);

  if (!shipment) {
    return (
      <IonList>
        {/* <IonListHeader>データがありません。</IonListHeader> */}
      </IonList>
    );
  }

  return (
    <IonItemSliding
      ref={ionItemSlidingRef}
      class={'track-' + shipment.jan.toLowerCase()}
      style={hide ? { display: 'none' } : {}}
    >
      {(shipment.image !== "") && 
      <IonItem>
        <IonImg src={shipment.image} alt="Shipment Image" style={{ width: '200px', height: '200px' }} />
      </IonItem>
      }
      <IonItem>
        <IonLabel>
          <h3 style={{ fontSize: '20px' }}>
            商品コード : {(shipment.jan !== "" && shipment.original_num !== "") ? `${shipment.jan} - ${shipment.original_num}` : shipment.jan + shipment.original_num}
          </h3>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            RACK NUM : {shipment.rack_num}
          </p>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            数量 : {shipment.quantity}
          </p>
          {/* <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            注文番号 : {shipment.order_num}
          </p> */}
        </IonLabel>
      </IonItem>
    </IonItemSliding>
  );
};

export default React.memo(ShipmentCard);
